import { JSX } from 'react';
import { DIMENSION_FONT_SIZE } from '../../../blueprint-classes/dimensions/constants';

import { ComponentDynamicSvgArgs } from '../../components/types/component-dynamic-svg.type';

// Default diameter is 2.25 inches (radius 1.125)
const DEFAULT_DIAMETER = 2.25;

// Gap between circle edge and label
const LABEL_GAP = 0.5;

export const umbrellaCutout = {
	item: ({ x, y, opacity = 1, fill = 'none', diameter = DEFAULT_DIAMETER, fontSize = DIMENSION_FONT_SIZE }: ComponentDynamicSvgArgs): JSX.Element => {
		const radius = diameter / 2;
		// If x/y not provided, center the circle (offset by -radius)
		const xPos = x ?? -radius;
		const yPos = y ?? -radius;

		// Center of the circle in local coordinates
		const cx = radius;
		const cy = radius;

		// Position for diameter label - top right of circle, outside
		// Offset X by radius + gap, Y by radius + gap + half font size for proper baseline alignment
		const labelX = cx + radius + LABEL_GAP;
		const labelY = cy - radius - LABEL_GAP - (fontSize * 0.3);

		return <g transform={`translate(${xPos}, ${yPos})`} opacity={opacity} pointerEvents="all">
			{/* Invisible fill for hit detection / dragging */}
			<circle cx={cx} cy={cy} r={radius} fill="transparent" stroke="none" pointerEvents="all"/>
			{/* Visible outline */}
			<circle cx={cx} cy={cy} r={radius} fill={fill} stroke="black" strokeWidth="0.125" pointerEvents="none"/>

			{/* Diameter label */}
			<text
				x={labelX}
				y={labelY}
				textAnchor="start"
				dominantBaseline="auto"
				fontSize={fontSize}
				fill="black"
				pointerEvents="none"
			>
				{diameter}"D
			</text>
		</g>;
	},
	cutout: ({ x, y, opacity = 1, fill = '#EDF2F7', diameter = DEFAULT_DIAMETER }: ComponentDynamicSvgArgs): JSX.Element => {
		const radius = diameter / 2;
		// If x/y not provided, center the circle (offset by -radius)
		const xPos = x ?? -radius;
		const yPos = y ?? -radius;
		return <g transform={`translate(${xPos}, ${yPos})`} opacity={opacity} pointerEvents="none">
			<circle cx={radius} cy={radius} r={radius} fill={fill} stroke="none"/>
		</g>;
	}
};
